<section [ngClass]="
    {
        'autopay-terms': true,
        'autopay-terms--expanded': isExpanded 
    }" [formGroup]="formGroup">
    <app-form-checkbox [inputId]="'ALL'" [formGroup]="formGroup" [formControlName]="controlName"
        [isErrorContainer]="false" [label]="autopayTermsText + ' <sup>*</sup>'" [bolded]="true"></app-form-checkbox>
</section>
<a class="expandable" (click)="isExpanded = !isExpanded">{{isExpanded ? ('SHARED.AUTOPAY.collapse' | translate) :
    ('SHARED.AUTOPAY.expand' | translate)}}</a>
@if (formGroup.get(controlName).hasError('required') && formGroup.get(controlName).touched) {
<p class="error">{{('SHARED.AUTOPAY.required' | translate)}}</p>
}